import React, { FocusEvent, useCallback } from 'react'
import { useField } from 'react-final-form'

import { resolveName } from '../hooks'
import { TextField, TextFieldProps } from '../TextField'

export interface DecimalFieldProps extends TextFieldProps {
  precisao?: number
  enableFormatOnBlur?: boolean
}

const pattern = new RegExp(/[^\d,]+/g)

const parse = (value: string, precisao: number) => {
  if (value.startsWith(',')) value = value.slice(1)

  // remove o que não é numero e vírgula
  value = value.replace(pattern, '')

  const primeiraVirgulaPos = value.indexOf(',')

  if (primeiraVirgulaPos >= 0) {
    // remove todas as vírgulas depois da primeira
    value = value.slice(0, primeiraVirgulaPos + 1) + value.slice(primeiraVirgulaPos, value.length)?.replace(/,/g, '')
  }

  if (value.indexOf(',') >= 0) value = value.substring(0, value.indexOf(',') + precisao + 1)

  return value
}

export function DecimalField(props: DecimalFieldProps) {
  const { precisao, enableFormatOnBlur, ...rest } = props
  const {
    input: { onChange },
  } = useField(resolveName(props.name))

  const internalParse = useCallback(
    (value: string) => {
      const parsedValue = parse(value, precisao)

      if (parsedValue === '') return null

      return parsedValue
    },
    [precisao]
  )

  const addTrailingZero = (value: string) => {
    if (!value || !enableFormatOnBlur) return value
    if (value?.endsWith(',')) return value + '0'

    return value
  }

  const handleOnBlur = (event: FocusEvent<HTMLInputElement>) => {
    if (!enableFormatOnBlur) return

    const target = event.target as HTMLInputElement
    onChange(addTrailingZero(target.value))
  }

  return <TextField onBlur={handleOnBlur} parse={internalParse} {...rest} />
}

DecimalField.defaultProps = {
  precisao: 2,
  enableFormatOnBlur: true,
}
